import { isEasterSeason } from '../utils/seasonalDecor';
import { easterPatternDark, easterPatternLight } from './easterPattern';

const buildEasterTheme = (isDarkTheme: boolean, enabled: boolean) => ({
    enabled,
    headerHoverBackground: isDarkTheme ? 'rgba(238, 203, 255, 0.18)' : 'rgba(232, 190, 243, 0.18)',
    cardBorderColor: isDarkTheme ? 'rgba(231, 198, 255, 0.28)' : 'rgba(223, 181, 238, 0.68)',
    headerBorderColor: isDarkTheme ? 'rgba(232, 191, 255, 0.34)' : 'rgba(221, 174, 236, 0.42)',
    headerIndicatorColor: isDarkTheme ? '#F1C7FF' : '#D39AE8',
    headerIndicatorBottom: '5px',
    headerLine: {
        bottom: '-18px',
        height: '22px',
        filter: 'saturate(0.64) brightness(1.02) contrast(0.9)',
        opacity: 0.92
    },
    badgeGlow: isDarkTheme
        ? 'drop-shadow(0 2px 8px rgba(241, 199, 255, 0.28))'
        : 'drop-shadow(0 2px 6px rgba(211, 154, 232, 0.22))',
    whatsNewInactive: {
        color: isDarkTheme ? '#F6E8FF' : '#6C8FDB',
        borderColor: isDarkTheme ? 'rgba(232, 198, 255, 0.52)' : 'rgba(108, 143, 219, 0.56)',
        backgroundColor: isDarkTheme ? 'rgba(214, 168, 238, 0.12)' : 'rgba(250, 233, 246, 0.72)',
        hoverBackgroundColor: isDarkTheme ? 'rgba(214, 168, 238, 0.2)' : 'rgba(238, 230, 252, 0.96)',
        hoverBorderColor: isDarkTheme ? 'rgba(232, 198, 255, 0.66)' : 'rgba(108, 143, 219, 0.72)'
    },
    whatsNewActive: {
        color: isDarkTheme ? '#2F173D' : '#5F84D6',
        background: isDarkTheme
            ? 'linear-gradient(180deg, #F3C8EA 0%, #DCC7FF 100%)'
            : 'linear-gradient(180deg, #F9D9EF 0%, #E5D8FF 100%)',
        hoverBackground: isDarkTheme
            ? 'linear-gradient(180deg, #EFB8E3 0%, #D0B9FF 100%)'
            : 'linear-gradient(180deg, #F7CDE8 0%, #DED0FF 100%)',
        activeBackground: isDarkTheme
            ? 'linear-gradient(180deg, #EAB0DE 0%, #C8AEFF 100%)'
            : 'linear-gradient(180deg, #F4C4E3 0%, #D7C8FF 100%)',
        boxShadow: isDarkTheme ? '0 6px 18px rgba(221, 174, 236, 0.24)' : '0 6px 18px rgba(211, 154, 232, 0.18)'
    },
    backgroundPattern: {
        dataUri: isDarkTheme ? easterPatternDark : easterPatternLight,
        size: '360px 360px',
        position: '-30px -18px'
    }
});

const easterThemeCache = {
    darkEnabled: buildEasterTheme(true, true),
    lightEnabled: buildEasterTheme(false, true),
    darkDisabled: buildEasterTheme(true, false),
    lightDisabled: buildEasterTheme(false, false)
};

export const getEasterTheme = (isDarkTheme: boolean) => {
    const enabled = isEasterSeason();

    if (isDarkTheme) {
        return enabled ? easterThemeCache.darkEnabled : easterThemeCache.darkDisabled;
    }

    return enabled ? easterThemeCache.lightEnabled : easterThemeCache.lightDisabled;
};

export const getEasterPaletteOverrides = (isDarkTheme: boolean) => {
    const easterTheme = getEasterTheme(isDarkTheme);

    return {
        headerControlHoverBackground: easterTheme.enabled ? easterTheme.headerHoverBackground : undefined
    };
};

export const getEasterComponentOverrides = (isDarkTheme: boolean) => {
    const easterTheme = getEasterTheme(isDarkTheme);

    return {
        cardBorder: easterTheme.enabled ? `1px solid ${easterTheme.cardBorderColor}` : undefined
    };
};
